/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit UpdateAction/view.blocks to change it.
import * as fromData from 'Simple/Data'
import React from 'react'
import TysiaButton from 'DesignSystem/TysiaButton/index'
import TysiaButtonText from 'DesignSystem/TysiaButton/TysiaButtonText/index'



/** @type {import('Simple/types.js').View} */
export default function UpdateAction({
  children,
  viewPath = "/DesignSystem/DataVaxiomEmployeeProfessionalsRelationshipsItem/Edit/Content/UpdateAction",
  onSubmit,
  isSubmitting
  
}) {
let editProfessionalSubmitData = fromData.useDataSubmit({ viewPath,
context: 'edit_professional',
})
let editProfessionalIsSubmittingData = fromData.useDataIsSubmitting({ viewPath,
context: 'edit_professional',
})
  return (<React.Fragment
>
<TysiaButton
  viewPath={`${viewPath}/TysiaButton`}
 block={true}
 data="edit_professional"
 onClick={editProfessionalSubmitData}
 disabled={editProfessionalIsSubmittingData}
>
{childProps => (
<TysiaButtonText
{...childProps}
  viewPath={`${viewPath}/TysiaButtonText`}
 text="Update Professional"
/>
)}
</TysiaButton>
{children}
</React.Fragment>)
}